import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useGenerateIncentiveOfferPurchaseContractModal } from '../context/GenerateIncentiveOfferPurchaseContractModalContext';

const GenerateIncentiveOfferPurchaseContractModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useGenerateIncentiveOfferPurchaseContractModal();

  return (
    <Modal.Header>
      <h5 className="modal-title mb-0">{t('GeneratingPurchaseContract')}</h5>

      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default GenerateIncentiveOfferPurchaseContractModalHeader;
